import { render, staticRenderFns } from "./TemplateTerminliste.vue?vue&type=template&id=10977324"
import script from "./TemplateTerminliste.vue?vue&type=script&lang=js"
export * from "./TemplateTerminliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports